import types from '../actionTypes/ContextActionTypes';

/**
 * Reducer to handle the application context changes
 */

export default function ContextReducer(state = {}, action) {
    switch (action.type) {
        case types.APP_ON_CONTEXT_READY:
            return action.context;
        default:
            return state;
    }
}
